type AnalyticsValue = string | number | boolean | null | undefined;

export type AnalyticsProperties = Record<string, AnalyticsValue>;

function cleanProperties(
  properties?: AnalyticsProperties,
): Record<string, string | number | boolean | null> {
  if (!properties) return {};

  return Object.fromEntries(
    Object.entries(properties).filter(
      (entry): entry is [string, string | number | boolean | null] => entry[1] !== undefined,
    ),
  );
}

export function trackUmamiEvent(name: string, properties?: AnalyticsProperties) {
  if (typeof window === 'undefined' || !window.umami) return;

  window.umami.track(name, cleanProperties(properties));
}
